// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useCallback, useEffect, useRef } from 'react';
import { isInsideNestedPopover, isInsideRefs } from '@front/sharedcomponents/Popover/popover.utils';
export function usePopover({ ref: menuRef, excludeRefs = [], onOutsideClick, isPinned = false }) {
    const excludeRefsRef = useRef(excludeRefs);
    excludeRefsRef.current = excludeRefs;
    useEffect(() => {
        if (isPinned || onOutsideClick === undefined) {
            return;
        }
        const handleOutsideClick = (event) => {
            const target = event.target;
            if (target === null) {
                return;
            }
            const menuElement = menuRef.current;
            const isClickInsideMenu = (menuElement === null || menuElement === void 0 ? void 0 : menuElement.contains(target)) === true;
            const isClickOnExcluded = isInsideRefs(target, excludeRefsRef.current);
            const isClickInsideNested = isInsideNestedPopover(menuElement, target);
            if (!isClickInsideMenu && !isClickOnExcluded && !isClickInsideNested) {
                onOutsideClick(event);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [menuRef, onOutsideClick, isPinned]);
    const getPopoverStyle = useCallback(({ top, left, minWidth, maxWidth, minHeight, maxHeight }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ position: 'fixed' }, (minWidth > 0 && { minWidth: `${minWidth}px` })), (maxWidth > 0 && { maxWidth: `${maxWidth}px` })), (minHeight > 0 && { minHeight: `${minHeight}px` })), (maxHeight > 0 && { maxHeight: `${maxHeight}px` })), (top !== undefined && { top: `${top}px` })), (left !== undefined && { left: `${left}px` }))), []);
    return { getPopoverStyle };
}
